
import { defineComponent,toRefs,reactive } from 'vue';

export default defineComponent({
  setup(){
      interface DataProps{
          works:{
              imgs: string,
              title: string,
              text: string
          }[]
      }
      const data:DataProps = reactive({
          works:[
                {
                    imgs:require("../../assets/imgs/home/work_a.png"),
                    title:'Invite Friends',
                    text:'Invite your friends to claim the FREE ZUS device by email, sharing your link or posting on social.'
                },
                {
                    imgs:require("../../assets/imgs/home/work_b.png"),
                    title:'Earn Real Cash',
                    text:'Get real cash when your friends claim their free ZUS with your link.'
                },
                {
                    imgs:require("../../assets/imgs/home/work_c.png"),
                    title:'Repeat',
                    text:'Keep referring friends! The more you invite, the more you earn.'
                }
          ]
      })
      const refData = toRefs(data)
      return {
          ...refData
      }
  }
})
